import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import NoCommunitiesIcon from '../../img/search-results.svg';

const NoMedia = () => {
  const classes = useStyles();

  return (
    <Box mb={1} mt={3} alignItems="center" textAlign="center">
      <img
        className={classes.imageSize}
        src={NoCommunitiesIcon}
        alt="not found"
      />
      <Box>No Media found</Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  imageSize: {
    width: '80px',
    height: '80px',
  },
}));

export default NoMedia;
